/** The badge colours a rule can flag in, named after the `Badge` variant each one uses. */
export const RULE_COLORS = ["yellow", "red", "green", "blue", "violet", "neutral"] as const

export type RuleColor = (typeof RULE_COLORS)[number]

export const DEFAULT_RULE_COLOR: RuleColor = "yellow"
